export enum DifferenceActions {
  updateGmb = 'updateGmb',
  acceptDifference = 'acceptDifference',
  acceptGoogleUpdateValue = 'acceptGoogleUpdateValue',
}

export const CorrespondingBeValue = {
  [DifferenceActions.updateGmb]: 'blsValue',
  [DifferenceActions.acceptDifference]: 'gmbValue',
  [DifferenceActions.acceptGoogleUpdateValue]: 'googleUpdateValue',
};

export const CorrespondingCheckCircleValue = {
  [DifferenceActions.updateGmb]: 'gmbUpdateSelected',
  [DifferenceActions.acceptDifference]: 'acceptDifferencesSelected',
  [DifferenceActions.acceptGoogleUpdateValue]: 'acceptGoogleValueSelected',
};

export const CorrespondingColumnHeading = {
  [DifferenceActions.updateGmb]: 'LSC Value',
  [DifferenceActions.acceptDifference]: 'GBP Value',
  [DifferenceActions.acceptGoogleUpdateValue]: 'Google update value',
};

export const CorrespondingInfoMenuContent = {
  [DifferenceActions.updateGmb]: 'Selecting an LSC value will override the current value in GBP.',
  [DifferenceActions.acceptDifference]: 'Selecting a GBP value will preserve the GBP value and thus accept the difference.',
  // TODO replace lorem ipsum
  [DifferenceActions.acceptGoogleUpdateValue]: 'Selecting a Google Update value will lorem ipsum.',
};

